import { getTextColorByBackground }  from '../../../../utils/stylesUtils'; 
import { formatNumberBR } from '../../../../utils/stylesUtils';
const PxoDescargaTable = ({tableData, allowNames}) => {
    
    const { pxoDescargaColumns, pxoDescargaRows } = tableData

    const backgroundColor   = tableData.hexColor
    const fontColor         = getTextColorByBackground(backgroundColor)

    const getRowClass = (row) => {

        if (row.rowType  === 'grand_total')     return 'bg-[#002A68] text-white font-bold ';
        if (row.rowType === 'bank_total' )      return 'border-b border-green-500 font-bold';
        if (row.rowType === 'yard_total' )      return 'bg-[#7B8C96] font-semibold text-white';
        return '';

    };

    return (
        <div>
            <table className="shadow-md">

                <thead>
                    <tr
                        style={{ backgroundColor, color: fontColor }}
                    >   
                        {allowNames && (
                            <>
                                <th></th>
                                <th></th>
                            </>
                        )}
                        
                        {pxoDescargaColumns.map((column, index) => (
                            <th key={index}>   
                            
                                <div className="flex flex-col px-2" >
                                    
                                    <span>{column.name}</span>
                                
                                    <span className="font-normal text-[10px]">
                                        {column.timeInDays ? column.timeInDays : <>&nbsp;</>}
                                    </span>

                                </div>
                            </th>
                        ))}
                        
                    </tr>
                </thead>

                <tbody>
                        {pxoDescargaRows.map((row, j) => {
                            
                            const isTotal = row.isTotalRow;

                            const terminalName      = row.ownerTerminal?.name ?? '';
                            const productBranchName = row.ownerProductBranch?.name ?? '';
                            const pxoDescargaValues = row.pxoDescargaValues ?? [];

                            return (
                                <tr
                                    key={j}
                                    className={getRowClass(row)} 
                                >
                                   {allowNames && (
                                        
                                        isTotal ? (
                                            <>
                                                <td colSpan={2} className="text-left px-1 pr-2 py-[3px] text-sm">
                                                    {productBranchName}
                                                </td>
                                            </>
                                        ) : (
                                            <>
                                                <td className="text-left px-1 pr-2 py-[3px] text-sm">
                                                    {terminalName}
                                                </td>
                                                <td className="text-left text-sm">
                                                    {productBranchName}
                                                </td>
                                            </>
                                        )
                                    )}

                                    {pxoDescargaValues.map((valueItem, i) => (
                                        <td key={i} className="text-right px-1 text-[14px] min-w-[55px]">
                                            {formatNumberBR(valueItem.value)}
                                        </td>
                                    ))}
                                    
                                </tr>
                            );
                        })}
                    </tbody>
            </table>

        </div>
    )

}

export default PxoDescargaTable